import { useState } from "react";
import Game, { GAMESTATES } from "../../model/game";
import { setGameState, setGameInfo, incrementQuestionNumber, incrementPercentage } from "../providers/game";

export function useGame(): [Game, Function, Function, Function, Function] {
    const options: string[] = [];
    const [state, setState] = useState({
        state: GAMESTATES.START_GAME, question: "", options: options, duration: 0, questionNumber: 0, percentage1: 0, percentage2: 0,
    });

    return [state,
        (matchmakingState: GAMESTATES) => setGameState(setState, matchmakingState),
        (question: string, options: string[], duration: number) => setGameInfo(setState, question, options, duration),
        () => incrementQuestionNumber(setState),
        (percentage1: number, percentage2: number) => incrementPercentage(setState, percentage1, percentage2),
    ];
}
